import { signedDistanceInDirectionOf } from '@geometry'
import { v4 } from 'uuid'
import { interpolate } from '@utils'

export interface SplitData {
  newPosition: ShapeObject
  updatedPosition: ShapeObject
}

export const splitVerticalSlabLikeParallelToSpan = (element: ShapeObject, splitPoint: Point) => {
  const {
    shape: { points },
  } = element
  const A = points[0]
  const B = points[1]
  const C = points[2]
  const D = points[3]
  const P = splitPoint

  const baseAxisDirection = B.sub(A).normalize()
  const distanceAtoPalongBase = signedDistanceInDirectionOf(A, P, baseAxisDirection)
  const E = A.add(baseAxisDirection.multiplyScalar(distanceAtoPalongBase))
  const FRatio = distanceAtoPalongBase / A.distanceTo(B)
  const F = interpolate(D, C, FRatio)

  const elementWithoutLabel = { ...element }
  delete elementWithoutLabel.label
  const updatedPosition = {
    ...element,
    shape: { points: [A, E, F, D] },
  }
  const newPosition = {
    ...elementWithoutLabel,
    guid: v4(),
    shape: { points: [E, B, C, F] },
  }

  const splitData = {
    newPosition: newPosition,
    updatedPosition: updatedPosition,
  }
  return splitData
}

export const splitVerticalSlabLikeOrthogonalToSpan = (element: ShapeObject, splitPoint: Point) => {
  const {
    shape: { points },
  } = element
  const A = points[0]
  const B = points[1]
  const C = points[2]
  const D = points[3]
  const P = splitPoint

  // For orthogonal split, we need to project P onto the vertical line AD or BC
  // and find the horizontal split line that goes through this projection
  const verticalDirection = D.sub(A).normalize()
  const distanceAtoPalongVertical = signedDistanceInDirectionOf(A, P, verticalDirection)
  const E = B.add(verticalDirection.multiplyScalar(distanceAtoPalongVertical))
  const F = A.add(verticalDirection.multiplyScalar(distanceAtoPalongVertical))

  // The split creates two regions:
  // 1. Lower region (red in sketch): A, B, F, E
  // 2. Upper region (green in sketch): E, F, C, D

  const elementWithoutLabel = { ...element }
  delete elementWithoutLabel.label
  const updatedPosition = {
    ...element,
    shape: { points: [A, B, E, F] }, // Lower rectangular region
  }
  const newPosition = {
    ...elementWithoutLabel,
    guid: v4(),
    shape: { points: [F, E, C, D] }, // Upper region
  }

  const splitData = {
    newPosition: newPosition,
    updatedPosition: updatedPosition,
  }
  return splitData
}
